import { render, staticRenderFns } from "./CatalogueMobileFilters.vue?vue&type=template&id=0542b45c"
import script from "./CatalogueMobileFilters.vue?vue&type=script&lang=js"
export * from "./CatalogueMobileFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports